import type { AppointmentType } from '../types';

/**
 * Whether the current user may mutate (edit/delete) the given appointment type.
 *
 * Org-owned types are managed practice-wide and require the org-configurable
 * `manage_appointment_types` permission — the backend enforces this in
 * EncounterTypeService for every route, including the provider-level ones.
 * Provider-owned types are personal and remain self-managed.
 */
export const canMutateAppointmentType = (
  appointmentType: Pick<AppointmentType, 'owner_scope'> | null | undefined,
  canManageAppointmentTypes: boolean,
): boolean =>
  appointmentType?.owner_scope === 'organization' ? canManageAppointmentTypes : true;

/**
 * Extract the API error message from an RTK Query error body, if present.
 * Backend errors carry user-appropriate copy (e.g. the 403 from the
 * manage_appointment_types gate), so prefer it over generic fallbacks.
 */
export const getApiErrorMessage = (error: unknown): string => {
  if (!error || typeof error !== 'object' || !('data' in error)) return '';
  const data = (error as { data?: { message?: unknown; error?: unknown } }).data;
  const message = data?.message ?? data?.error;
  return typeof message === 'string' ? message : '';
};
